// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PartConfigBrake extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  basePrice!: number;
  deleted?: Date;
  disableTireSelection!: boolean;
  displayOrder?: number;
  isTorsionSuspension!: boolean;
  name?: string;
  price2Axle!: number;
  price3Axle!: number;
  value!: number;
}

